import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { ServiceHistory } from "@/components/ServiceHistory";
import { BookingSection } from "@/components/BookingSection";
import { Footer } from "@/components/Footer";
import { AiChat } from "@/components/AiChat";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { scrollToId } from "@/lib/site";

export default function Home() {
  const [selectedService, setSelectedService] = useState(null);

  const handleBook = (service) => {
    setSelectedService(service);
    scrollToId("booking");
  };

  return (
    <div className="App" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services onBook={handleBook} />
        <ServiceHistory />
        <BookingSection selectedService={selectedService} />
      </main>
      <Footer />
      <WhatsAppButton />
      <AiChat />
    </div>
  );
}
